// LOGO 感知哈希:16x16 dHash → 256 位(64 个 hex 字符)。
// 纯浏览器实现:缩到 17x16 灰度,横向相邻比较。对同一数字图像/截图鲁棒,
// 对歪斜实拍照片较弱——LOGO 通道 v0 定位是「截图/正拍识别」。
export function computeLogoHash(input: HTMLImageElement | HTMLVideoElement): string | null {
  const w = 17;
  const h = 16;
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const context = canvas.getContext("2d");
  if (!context) return null;
  try {
    context.drawImage(input, 0, 0, w, h);
    const { data } = context.getImageData(0, 0, w, h);
    let bits = "";
    for (let y = 0; y < h; y += 1) {
      for (let x = 0; x < w - 1; x += 1) {
        const i = (y * w + x) * 4;
        const j = (y * w + x + 1) * 4;
        const left = data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
        const right = data[j] * 0.299 + data[j + 1] * 0.587 + data[j + 2] * 0.114;
        bits += left > right ? "1" : "0";
      }
    }
    let hex = "";
    for (let i = 0; i < 256; i += 4) {
      hex += parseInt(bits.slice(i, i + 4), 2).toString(16);
    }
    return hex;
  } catch {
    return null; // 跨域画布污染等
  }
}

export async function resolveLogoOnServer(hash: string) {
  try {
    const response = await fetch("https://u.jic.io/v1/face/resolve-logo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ hash }),
    });
    const data = (await response.json()) as {
      ok?: boolean;
      count?: number;
      match?: { mode: string; slug: string; label: string; name: string; address: string | null; confidence: number } | null;
    };
    return data.ok ? { match: data.match || null, count: data.count || 0 } : null;
  } catch {
    return null;
  }
}
